export const blogData = [
  {
    id: 1,
    title: "My Masai Journey",
    description: "I am sharing my experience of 5 week journey in Masai",
    date: "Dec 14, 2021",
    image:
      "https://images.unsplash.com/photo-1473625247510-8ceb1760943f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1111&q=80",
    url: "https://medium.com/@sagarkumarpradhan2001/your-journey-in-masai-school-5a132f3da449",
  },
  {
    id: 2,
    title: "Goa Utsav",
    description: "Diwali celebration in Goa",
    date: "Dec 14, 2021",
    image:
      "https://images.rove.me/w_1920,q_85/rh732zyym1xug2uqzhh1/goa-shigmo.jpg",
    url: "https://medium.com/@sagarkumarpradhan2001/goa-utsav-e7b56d15976e",
  },
  //   {
  //     id: 3,
  //     title: "BEING ANONYMOUS: A BEGINNERS GUIDE",
  //     description: "Here are some basic ways to lay off the Radar",
  //     date: "Aug 14, 2020",
  //     image:
  //       "https://1.bp.blogspot.com/-GR19yCNbKCE/XuRcKEfKvhI/AAAAAAAAAwY/srFWw5pOpzMibeJb__SmgZpx9dIpNNWqgCK4BGAsYHg/w640-h426/anonymous1.jpg",
  //     url: "https://hackzism.blogspot.com/2020/06/being-anonymous-beginners-guide.html",
  //   },
  //   {
  //     id: 4,
  //     title: "CHECK INTERNET SPEED FROM THE COMMAND LINE",
  //     description:
  //       "Want to check your internet speed from the terminal? Here's the perfect way to the that.",
  //     date: "Sep 17, 2020",
  //     image:
  //       "https://1.bp.blogspot.com/-XTVMsZP3HaM/Xxpl394txlI/AAAAAAAABws/zovXWiuNGg4TzBwYYVFfJ1ixDb3JfVokgCNcBGAsYHQ/w400-h195/speedtest.png",
  //     url: "https://hackzism.blogspot.com/2020/07/check-internet-speed-from-command-line.html",
  //   },
  //   {
  //     id: 5,
  //     title:
  //       "GET MICHAEL'S OR TREVOR'S VEHICLES FULLY UPGRADED IN GTA V FOR FREE",
  //     description:
  //       "In case you haven't heard of this game, GTA stands for 'Grand Theft Auto'. It is an open-world game published by Rockstar Games.",
  //     date: "Oct 1, 2020",
  //     image:
  //       "https://1.bp.blogspot.com/-jhdtUBIRD_s/XxLFKQuRz9I/AAAAAAAABsM/mClfbfDFKvsUwA7Wyi25Lzu3DEmL2lxrACNcBGAsYHQ/s1919/gta.jpg",
  //     url: "https://hackzism.blogspot.com/2020/07/how-can-you-get-michaels-or-trevors.html",
  //   },
];

// Do not remove any fields.
// Leave it blank instead as shown below.

/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/
